import React, { type ReactNode, Suspense } from "react";
import ReactDOM from "react-dom";

import { AppContainer } from "react-hot-loader";
import ErrorBoundary from "./components/error_boundary";
import { AppThemeProvider } from "./components/shared/app/AppThemeProvider";
import { Loader } from "./components/shared/loader/LoaderNew";

export const renderIntoApp = (children: ReactNode) => {
  ReactDOM.render(
    <AppContainer>
      <AppThemeProvider>
        <ErrorBoundary>
          <Suspense fallback={<Loader />}>{children}</Suspense>
        </ErrorBoundary>
      </AppThemeProvider>
    </AppContainer>,
    document.getElementById("root")
  );
};
